import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointDown } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { PasswordField } from '../../../components/Authentication/components/PasswordField.js';
import { LabelXSmall, Stack, ValidationChecker } from '../../../primitives/index.js';
import { AUTHENTICATION_QA_ID, qaId } from '../../../utils/qaId.js';
export const PasswordContent = ({
  checkers,
  onChange,
  confirmationPassword,
  newPassword,
  testIdType,
  label,
  ...restProps
}) => {
  const {
    t
  } = useTranslation('authentication');
  const isPasswordsEqual = newPassword === confirmationPassword;
  const isPasswordSelected = newPassword !== '' && confirmationPassword !== '';
  const smDown = useBreakpointDown('sm');
  const size = smDown ? 'small' : 'medium';
  return _jsxs(Stack, {
    spacing: "medium",
    children: [_jsx(PasswordField, {
      id: "new-password",
      autoComplete: "new-password",
      onChange: e => onChange({
        confirmationPassword,
        newPassword: e.target.value
      }),
      label: label,
      size: size,
      "data-testid": qaId(AUTHENTICATION_QA_ID, `${testIdType}-newPassword-textfield`),
      ...restProps
    }), _jsx(PasswordField, {
      id: "new-password-confirm",
      autoComplete: "new-password",
      "data-testid": qaId(AUTHENTICATION_QA_ID, `${testIdType}-newPasswordConfirm-textfield`),
      onChange: e => onChange({
        newPassword,
        confirmationPassword: e.target.value
      }),
      label: t('passwordContent.confirmPassword'),
      invalid: !isPasswordsEqual && isPasswordSelected,
      message: !isPasswordsEqual && isPasswordSelected ? t('passwordContent.passwordsNotMatch') : undefined,
      size: size
    }), _jsxs(Stack, {
      spacing: "small",
      "data-testid": qaId(AUTHENTICATION_QA_ID, `${testIdType}-passwordValidation-container`),
      children: [_jsx(LabelXSmall, {
        color: "contentSecondary",
        children: t('passwordContent.passwordMandatory')
      }), checkers?.map((item, index) => _jsx(ValidationChecker, {
        "data-testid": qaId(AUTHENTICATION_QA_ID, `${testIdType}-validation-${index}`),
        disabled: newPassword === '',
        valid: item.validation,
        label: item.label
      }, index))]
    })]
  });
};